import { render, staticRenderFns } from "./ViewInspection.vue?vue&type=template&id=2a314a5d&scoped=true&"
import script from "./ViewInspection.vue?vue&type=script&lang=ts&"
export * from "./ViewInspection.vue?vue&type=script&lang=ts&"
import style0 from "./ViewInspection.vue?vue&type=style&index=0&id=2a314a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a314a5d",
  null
  
)

export default component.exports